import { Outlet } from "react-router-dom";
import { useLocale } from "./hooks/useLocale";
import { IntlProvider } from "react-intl";
import RouteWrapper from "./components/RouteWrapper";

const App = () => {
  const { locale, messages } = useLocale();

  return (
    <IntlProvider messages={messages} locale={locale}>
      <RouteWrapper>
        <Outlet />
      </RouteWrapper>
    </IntlProvider>
  );
};

export default App;
